// extracted by mini-css-extract-plugin
export default {"container":"_CFuR","card":"M0wo0"};